module.exports = __webpack_public_path__ + "img/creditsafe.dba02910.png";